import React from 'react';
import {useShallow} from 'zustand/react/shallow';
import {useQuestionTranslationStore} from 'client/components/QuestionTypes/shared/TranslationSection';

import HowOthersAnswered from './HowOthersAnswered.react';

type HowOthersAnsweredWrapperProps = any;

const HowOthersAnsweredWrapper = (props: HowOthersAnsweredWrapperProps) => {
  const {showTranslations} = useQuestionTranslationStore(
    useShallow((state) => ({
      showTranslations: state.showTranslations && state.translationSettings.question
    }))
  );
  return showTranslations ? null : <HowOthersAnswered {...props} />;
};

export default HowOthersAnsweredWrapper;
